module.exports = __webpack_public_path__ + "static/img/RZ_pic04.02e995d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic04.png
// module id = ENEV
// module chunks = 5